// Accounts feature — query-key gyár + a lista-szűrő típusa. A tényleges hívásokat a route a tipizált
// ts-rest kliensen (`api.accounts.*`) intézi; a kulcsok itt élnek (cache-egységesítés). A `@atlas/contracts`
// a szerződés forrás-igazsága — itt csak kulcs/segéd-logika van (a clients/contacts feature-mintára).

/** A lista-lekérdezés szűrői (a query-kulcs része — szűrő-/rendezés-váltás új cache-bejegyzést nyit).
 *  A legacy multi-oszlop rendezést megtartjuk (a fiók-lista sok, technikai oszloppal): a `sort` a rendezés-KULCS,
 *  az `order` az irány. A `q`/`type`/`category`/`status` a toolbar-szűrők. */
export interface AccountListFilters {
  q: string;
  type: string;
  category: string;
  status: string;
  sort: string;
  order: 'asc' | 'desc';
}

/** Query-kulcs gyár — a lista/detail cache egységes címzése (invalidálás + optimista írás). */
export const accountKeys = {
  all: ['accounts'] as const,
  lists: () => ['accounts', 'list'] as const,
  list: (filters: AccountListFilters) => ['accounts', 'list', filters] as const,
  detail: (id: string) => ['accounts', 'detail', id] as const,
};
